import { useEffect, useState } from "react";
import Header from "../components/Header";
import HomeHeroCarousel from "../components/HomeHeroCarousel";
import HomeServices from "../components/HomeServices";
import SystemsSection from "../components/SystemsSection";
import Footer from "../components/Footer";
import PageLoader from "../components/PageLoader";
import { fetchServices } from "../api";

export default function HomePage() {
  // The hero carousel, services and systems sections each fetch their own DB content, but this
  // gate waits for the primary above-the-fold data before showing anything, so visitors see the
  // loader (not a blank Header with empty gaps) until real content is ready.
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetchServices()
      .then(() => { if (!cancelled) setReady(true); })
      .catch(() => { if (!cancelled) setReady(true); });
    return () => { cancelled = true; };
  }, []);

  if (!ready) {
    return <PageLoader />;
  }

  return (
    <>
      <Header />
      <div className="h-16 md:h-16 lg:h-16" />
      <HomeHeroCarousel />
      <HomeServices />
      <SystemsSection />
      <Footer />
    </>
  );
}
